import { createSlice } from '@reduxjs/toolkit';

import {
  SetMessageOverviewsPayload,
  SetMessageOwnerPayload,
  SetMessagesPayload,
  SetSupportTemplatePayload,
  SupportState
} from './support.types';

export const initialState: SupportState = {
  supportTemplate: undefined,
  messageOverviews: [],
  messageOwner: undefined,
  messages: []
};

const SupportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setSupportTemplate: (state, action: SetSupportTemplatePayload) => {
      state.supportTemplate = action.payload;
    },
    setMessageOverviews: (state, action: SetMessageOverviewsPayload) => {
      state.messageOverviews = action.payload;
    },
    setMessageOwner: (state, action: SetMessageOwnerPayload) => {
      state.messageOwner = action.payload;
    },
    setMessages: (state, action: SetMessagesPayload) => {
      state.messages = action.payload;
    }
  }
});

export const { setSupportTemplate, setMessageOverviews, setMessageOwner, setMessages } = SupportSlice.actions;

export default SupportSlice.reducer;
